import router from "@/router";
import { createNamespacedHelpers } from "vuex";
import { extractDataAxios, extractErrorMessageAxios, extractValidationErrorsAxios } from "@/httpClient";
import { ADMIN } from "@/constants";

const user = {
  namespaced: true,
  name: "userStore",
  state: () => ({
    user: null,
    users: [],
    errors: "",
    role: "guest",
    fieldErrors: {},
    isLoading: false,
    pageNumber: 1
  }),
  getters: {
    isAuthenticated: (state) => !!state.user,
    users: (state) => state.users,
    role: (state) => state.role,
    guest: () => {
      const storageItem = window.localStorage.getItem("guest");
      if (!storageItem) return false;
      if (storageItem === "isGuest") return true;
      if (storageItem === "isNotGuest") return false;
    },
    isAdmin: (state) => state.role === ADMIN,
  },
  mutations: {
    SET_PAGE_NUMBER(state, pageNumber) {
      state.pageNumber = pageNumber;
    },
    SET_USER: (state, payload) => {
      state.user = payload;
    },
    SET_USERS: (state, users) => {
      state.users = users;
      state.isFetchedOnce = true;
    },
    SET_ROLE: (state, role) => {
      state.role = role;
    },
    REMOVE_USER(state, userId) {
      const userIndex = state.users.findIndex((user) => user.id == userId);
      state.users.splice(userIndex, 1);
    },
    SET_ERRORS: (state, errors) => {
      state.errors = errors;
    },
    SET_FIELD_ERRORS: (state, errors) => {
      state.fieldErrors = errors;
    },
    SET_LOADING: (state, loading) => {
      state.isLoading = loading;
    },
    UPDATE_SINGLE_USER: (state, user) => {
      const userIndex = state.users.findIndex((aUser) => aUser.id === user.id);
      state.users.splice(userIndex, 1, user);
    },
  },
  actions: {
    clearFieldErrors({ commit }) {
      commit("SET_FIELD_ERRORS", {});
    },
    async login({ dispatch, commit }, form) {
      try {
        commit("SET_FIELD_ERRORS", {});
        commit("SET_ERRORS", "");
        await window.axios.get("/sanctum/csrf-cookie");
        await window.axios.post("/login", form);
      } catch (err) {
        commit("SET_FIELD_ERRORS", extractValidationErrorsAxios(err));
        commit("SET_ERRORS", extractErrorMessageAxios(err));
      }
    },
    async logout({ commit, dispatch }) {
      await window.axios.post("/logout");
      commit("SET_USER", null);
      dispatch("setGuest", { value: "isGuest" });
      router.push({ name: "login" });
    },
    async fetchUser({ commit }) {
      try {
        const user = extractDataAxios(await window.axios.get("/api/user/auth"));
        commit("SET_USER", user);
        commit("SET_ROLE", user.role);
        return user;
      } catch (e) {
        commit("SET_ERRORS", extractErrorMessageAxios(e));
        commit("SET_USER", null);
      }
    },
    async fetchAllUsers({ commit }) {
      try {
        commit("SET_LOADING", true);
        const data = extractDataAxios(await window.axios.get("/api/users"));
        if (data) {
          commit("SET_USERS", data);
        }
        commit("SET_LOADING", false);
        return data;
      } catch (e) {
        commit("SET_ERRORS", extractErrorMessageAxios(e));
      }
    },
    async removeUser({ commit }, userId) {
      commit("REMOVE_USER", userId);
      const successfullyDeleted = extractDataAxios(await window.axios.delete("/api/users/" + userId));
      return successfullyDeleted;
    },
    setGuest(context, { value }) {
      window.localStorage.setItem("guest", value);
    },
  },
};

const { mapState, mapActions, mapGetters, mapMutations } = createNamespacedHelpers("user");
export { mapState, mapActions, mapGetters, mapMutations };
export default user;
